<template>
   <!-- .aside -->
   <aside class="bg-dark lter aside-md hidden-print hidden-xs" id="nav" v-if="MenuLaterale" style="position: absolute; top: 50px; left: 0; background-color: transparent; z-index: 999; pointer-events: none;">          
     <section class="vbox">
       <section class="w-f scrollable">
         <div class="slim-scroll" data-height="auto" data-disable-fade-out="true" data-distance="0" data-size="5px" data-color="#333333" :style="{ height: (Altezza - 100)+ 'px'}">
           <nav class="nav-primary hidden-xs">
             <ul class="nav"  style="pointer-events: all;">
               <template v-for="MenuItem in SideMenu.Children" :key="MenuItem.Data.IdMenu">
                  <VUESideMenuItem @onClickChiudiMenu="ClickChiudiMenu" @onClickNascondiAllMenu="ClickNascondiAllMenu" :MenuItem="MenuItem" :SideMenu="SideMenu"></VUESideMenuItem>
               </template>
             </ul>
           </nav>
         </div>
       </section>
     </section>
   </aside>

   <!-- /.aside -->
   <aside class="bg-dark lter aside-md hidden-print hidden-xs nav-xs" id="nav" v-else-if="!MenuLaterale" style="width:65px; position: absolute; top: 50px; left: 0; background-color: transparent; z-index: 999; pointer-events: none;">          
          <section class="vbox">
            <section class="w-f scrollable">
              <div class="slim-scroll" data-height="auto" data-disable-fade-out="true" data-distance="0" data-size="5px" data-color="#333333" :style="{ height: (Altezza - 100)+ 'px'}">
                
                <!-- nav -->
                <nav class="nav-primary hidden-xs" style="width:65px;">
                  <ul class="nav" style="pointer-events: all">
                    <template v-for="MenuItem in SideMenu.Children" :key="MenuItem.Data.IdMenu">
                     <VUESideMenuItem @onClickChiudiMenu="ClickChiudiMenu" :MenuItem="MenuItem" :SideMenu="SideMenu"></VUESideMenuItem>
                    </template>
                  </ul>
                </nav>
              </div>
            </section>
            <!-- <footer class="footer lt hidden-xs b-t b-dark" style="width:65px">
              <a data-toggle="class:nav-xs" class="pull-right btn btn-sm btn-dark btn-icon" @click="CambioMenuLaterale" style="width:37px;">
                <i class="fa fa-angle-left text-active"></i>
                <i class="fa fa-angle-right text"></i>
              </a>
            </footer> -->
          </section>
        </aside>


</template>

<script>
import VUESideMenuItem from './VUESideMenuItem.vue';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { SystemInformation } from '@/SystemInformation';
import { TZTree } from '@/utils/ZTreeObjects.js';

export default 
{
    name: "VUEAppSideMenu",
    props : ['Altezza', 'MenuAttuale', 'VisualizzaMenu'],
    emits : ['onClickChiudiMenuDaSideMenu', 'onClickNascondiAllMenuDaSideMenu'],
    mixins: [ MixInsGestioneTraduzioni ],
    data()
    {
      
       var SideMenu = new TZTree();
       SideMenu.HideExpandedNodeOnExpanding = true;
       SideMenu.SelectableLevels.push(1);
       return {

          SideMenu              : SideMenu,
          MenuLaterale          : true,
          LinguaUtente          : SystemInformation.UserInformation.Lingua
        }
    },

    components :
    {
       VUESideMenuItem,
    },

    methods: 
    {
      CambioMenuLaterale()
      {
        this.MenuLaterale = !this.MenuLaterale
        this.CreaMenu()
      },

      ClickChiudiMenu()
      {
        this.$emit('onClickChiudiMenuDaSideMenu')
      },

      ClickNascondiAllMenu()
      {
        this.SideMenu.Clear()
        this.$emit('onClickNascondiAllMenuDaSideMenu')
      },

      CreaMenu()
      {
        this.SideMenu.Clear();
        // let AMenu = null;

        if(this.MenuAttuale != undefined && this.VisualizzazioneMenuLaterale)
        {
          for (let i = 0; i < this.MenuAttuale.length; i++)
          {
            let VoceMenu = this.MenuAttuale[i]
            let AMenu = this.SideMenu.AddChild(this.MenuLaterale ? VoceMenu.DescFull : VoceMenu.DescShrink,
                                                { 
                                                  IdMenu      : VoceMenu.Id, 
                                                  IconCfg     : VoceMenu.IconCfg, 
                                                  ColorType   : VoceMenu.Color 
                                                });
            for (let j = 0; j < VoceMenu.ChildList.length; j++)
            {
              let Child  = VoceMenu.ChildList[j]
              let AMenu2 = AMenu.AddChild(Child.Descrizione,
                                          { 
                                            IdMenu          : Child.Id, 
                                            IconCfg         : "fa-angle-right", 
                                            IconCfgExpanded : "fa-angle-up", 
                                            IconCfgShrinked : "fa-angle-down"                              
                                          });
              if(Child.ChildList && Child.ChildList.length != 0)
              {
                for (let k = 0; k < Child.ChildList.length; k++)
                {
                  let Child2 = Child.ChildList[k]
                  AMenu2.AddChild(Child2.Descrizione,
                                  { 
                                    IdMenu          : Child2.Id, 
                                    IconCfg         : "fa-angle-right", 
                                    IconCfgExpanded : "fa-angle-up", 
                                    IconCfgShrinked : "fa-angle-down"                              
                                  });
  
                }
              }
            }
          } 
        }
      
        // this.SideMenu.AddChild(this.MenuLaterale? "Dashboard" : "Dash.",
        //                       { 
        //                         IdMenu      : TIdSideMenu.DASHBOARD, 
        //                         IconCfg     : "fa-dashboard", 
        //                         ColorType   : "bg-info" 
        //                       });                            
        // AMenu = this.SideMenu.AddChild(this.MenuLaterale? "Configurazioni" : "Config.",
        //                                 { 
        //                                   IdMenu      : TIdSideMenu.CONFIGURAZIONI, 
        //                                   IconCfg     : "fa-pencil", 
        //                                   ColorType   : "bg-success" 
        //                                 });
        // if (SystemInformation.UserInformation.Ruolo == 'A')
        // {
        //   AMenu.AddChild("Generale",
        //                   { 
        //                     IdMenu          : TIdSideMenu.CFG_GENERALE, 
        //                     IconCfg         : "fa-angle-right", 
        //                     IconCfgExpanded : "fa-angle-up", 
        //                     IconCfgShrinked : "fa-angle-down"
        //                   });
        // }
        // AMenu.AddChild("Gestione Siti",
        //                 { 
        //                   IdMenu          : TIdSideMenu.CFG_SITI, 
        //                   IconCfg         : "fa-angle-right", 
        //                   IconCfgExpanded : "fa-angle-up", 
        //                   IconCfgShrinked : "fa-angle-down"
        //                 });
        // AMenu = this.SideMenu.AddChild(this.MenuLaterale? "Gestione" : "Gest.",
        //                               { 
        //                                 IdMenu      : TIdSideMenu.AMM_GESTIONE, 
        //                                 IconCfg     : "fa-user", 
        //                                 ColorType   : "bg-warning" 
        //                               });
        // AMenu.AddChild("Gestione Utenti",
        //                 { IdMenu          : TIdSideMenu.AMM_GESTIONE_UTENTI, 
        //                   IconCfg         : "fa-angle-right", 
        //                   IconCfgExpanded : "fa-angle-up", 
        //                   IconCfgShrinked : "fa-angle-down"
        //                 });
        // if (SystemInformation.UserInformation.Ruolo == 'A')
        // {
        //   AMenu.AddChild("Gestione Messaggi",
        //                   {
        //                     IdMenu          : TIdSideMenu.AMM_GESTIONE_MESSAGGI, 
        //                     IconCfg         : "fa-angle-right", 
        //                     IconCfgExpanded : "fa-angle-up", 
        //                     IconCfgShrinked : "fa-angle-down"
        //                   });
        // }
      }
    },

    computed :
    {
      VisualizzazioneMenuLaterale:
      {
        get()
        {
          return this.VisualizzaMenu
        }
      },
    },

    watch:
    {
      MenuAttuale:
      {
        handler()
        {
          this.CreaMenu()
        },
        deep : true
      },

      VisualizzaMenu:
      {
        handler()
        {
          this.CreaMenu()
        },
        deep : true
      }
    },

    beforeMount()
    {
      this.CreaMenu()
    }

}
</script>
